<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('segmento-fundamental-ii')" class="main pb-4" id="about-main">
      <b-container fluid="lg">
        <b-card no-body class="p-4 shadow-sm card__sistemacpv p-4">
          <b-nav class="nav-books" tabs fill>
            <b-nav-item @click="setActive(index)" :class="{ 'active': activeIndex === index }"
              :active="activeIndex === index" v-for="(menu, index) in lists" :key="index">
              <i :class="menu.iconClass"></i>
              <span class="mr-auto">{{ menu.name }}</span>
            </b-nav-item>
          </b-nav>
          <div v-for="(menu, index) in lists" :key="index">
            <b-collapse @show="setActive(index)" @hide="clearActive(index)" :visible="activeIndex === index">
              <div class="mt-3" v-if="menu.turmas">
                <b-card no-body v-for="(turma, idx) in menu.turmas" :key="idx" class="mt-2 border-light shadow-none">
                  <template #header>
                    <div @click="toggleCollapse('colecaoCpv', idx)" class="button-toggle p-3"
                      v-if="menu.name == 'Coleção CPV'">
                      <div class="d-flex align-items-center justify-content-baseline">
                        <span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
                          turma.otherName }})</span></span>
                        <i :class="collapsedStates.colecaoCpv[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
                      </div>
                    </div>
                    <div @click="toggleCollapse('simuladoCpv', idx)" class="button-toggle p-3"
                      v-if="menu.name == 'Simulados'">
                      <div class="d-flex align-items-center justify-content-baseline">
                        <span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
                          turma.otherName }})</span></span>
                        <i :class="collapsedStates.simuladoCpv[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
                      </div>
                    </div>
                    <div @click="toggleCollapse('manualCpv', idx)" class="button-toggle p-3"
                      v-if="menu.name == 'Manual'">
                      <div class="d-flex align-items-center justify-content-baseline">
                        <span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
                          turma.otherName }})</span></span>
                        <i :class="collapsedStates.manualCpv[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
                      </div>
                    </div>
                  </template>
                  <b-collapse v-model="collapsedStates.colecaoCpv[idx]" v-if="menu.name == 'Coleção CPV'">
                    <div class="p-3">
                      <b-row>
                        <b-col cols="12" v-for="(book, idx) in turma.books" :key="idx" class="mt-2">
                          <router-link :to="{
                            name: 'render-conteudo-exclusivo',
                            params: { paramsForUrl: book.linkFree || '', nomeApostila: book.name || '' },
                            query: { material: formatParam(book.description) }
                          }">
                            <b-card no-body class="p-3 text-dark">
                              <div class="d-flex aling-items-center">
                                <i :class="book.iconClass" class="d-flex align-items-center"></i>
                                <span>{{ book.name }}</span>
                              </div>
                            </b-card>
                          </router-link>
                        </b-col>
                      </b-row>
                    </div>
                  </b-collapse>
                  <b-collapse v-model="collapsedStates.simuladoCpv[idx]" v-if="menu.name == 'Simulados'">
                    <div class="p-3">
                      <b-row>
                        <b-col cols="12" v-for="(book, idx) in turma.books" :key="idx" class="mt-2">
                          <router-link :to="{
                            name: 'render-conteudo-exclusivo',
                            params: { paramsForUrl: book.linkFree || '', nomeApostila: book.name || '' },
                            query: { material: formatParam(book.description) }
                          }">
                            <b-card no-body class="p-3 text-dark">
                              <div class="d-flex aling-items-center">
                                <i :class="book.iconClass" class="d-flex align-items-center"></i>
                                <span>{{ book.name }}</span>
                              </div>
                            </b-card>
                          </router-link>
                        </b-col>
                      </b-row>
                    </div>
                  </b-collapse>
                  <b-collapse v-model="collapsedStates.manualCpv[idx]" v-if="menu.name == 'Manual'">
                    <div class="p-3">
                      <b-row>
                        <b-col cols="12" v-for="(book, idx) in turma.books" :key="idx" class="mt-2">
                          <router-link :to="{
                            name: 'render-conteudo-exclusivo',
                            params: { paramsForUrl: book.linkFree || '', nomeApostila: book.name || '' },
                            query: { material: formatParam(book.description) }
                          }">
                            <b-card no-body class="p-3 text-dark">
                              <div class="d-flex aling-items-center">
                                <i :class="book.iconClass" class="d-flex align-items-center"></i>
                                <span>{{ book.name }}</span>
                              </div>
                            </b-card>
                          </router-link>
                        </b-col>
                      </b-row>
                    </div>
                  </b-collapse>
                </b-card>
              </div>
              <div class="mt-3" v-else>
                <b-card no-body class="mt-2 border-0 shadow-none">
                  <b-row>
                    <b-col cols="12" v-for="(book, i) in menu.books" :key="i" class="mt-2">
                      <router-link :to="{
                        name: 'render-conteudo-exclusivo',
                        params: { paramsForUrl: book.linkFree || '', nomeApostila: book.name || '' },
                        query: { material: formatParam(book.description) }
                      }">
                        <b-card no-body class="p-3 text-dark">
                          <div class="d-flex aling-items-center">
                            <i :class="book.iconClass" class="d-flex align-items-center"></i>
                            <span>{{ book.name }}</span>
                          </div>
                        </b-card>
                      </router-link>
                    </b-col>
                  </b-row>
                </b-card>
              </div>
            </b-collapse>
          </div>
        </b-card>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'dash-infantil',
  data() {
    return {
      pageTitle: 'ENSINO FUNDAMENTAL II',
      pageSubtitle: '',

      NamePermission: '',
      IndexPermission: '',

      activeIndex: 0,

      collapsedStates: {
        colecaoCpv: [],
        simuladoCpv: [],
        manualCpv: [],
        projetosCpv: [],
      },

      lists: [
        {
          id: 1,
          name: 'Coleção CPV',
          iconClass: 'fa-solid fa-book fa-sm mr-1',
          link_name: 'fundamental-2-colecao-cpv',
          colorCard: {
            'background-color': '#38aaf3',
            'border:': '1px solid #38aaf3',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-fundamental-ii',
          bg__link: 'infantil',
          turmas: [
            {
              name: '6º Ano',
              otherName: '',
              permission: 'segmento-fundamental-i',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/6-ano/6-ano-_-caderno-1-web.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-6.png',
                  bundle: 'F_fundamental',
                  name: '6º Ano - Caderno 1',
                  segment: '6',
                  discipline: '',
                  description: '6º Ano - Caderno 1',
                  journal: '',
                  toolTip: '',
                  isbn: 'ISBN: 978-85-86203-43-5',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/6-ano/6-ano-_-caderno-2.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-6-2.png',
                  bundle: 'F_fundamental',
                  name: '6º Ano - Caderno 2',
                  segment: '6',
                  discipline: '',
                  description: '6º Ano - Caderno - 2',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-86203-50-3',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/6-ano/6-ano-_-caderno-3.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-6-3.png',
                  bundle: 'F_fundamental',
                  name: '6º Ano - Caderno 3',
                  segment: '6',
                  discipline: '',
                  description: '6º Ano - Caderno - 3',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-86203-52-7',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/6-ano/6-ano-_-caderno-4.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-6-4.png',
                  bundle: 'F_fundamental',
                  name: '6º Ano - Caderno 4',
                  segment: '6',
                  discipline: '',
                  description: '6º Ano - Caderno - 4',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-86203-51-0',
                },
              ]
            },
            {
              name: '7º Ano',
              otherName: '',
              permission: 'segmento-fundamental-i',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/7-ano/7-ano-_-caderno-1-web.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-7-1.png',
                  bundle: 'F_fundamental',
                  name: '7º Ano - Caderno 1',
                  segment: '7',
                  discipline: '',
                  description: 'Coleção Didática -  7º Ano - Caderno - 1',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-86203-49-7',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/7-ano/7-ano-_-caderno-2.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-7-2.png',
                  bundle: 'F_fundamental',
                  name: '7º Ano - Caderno 2',
                  segment: '7',
                  discipline: '',
                  description: 'Coleção Didática - 7º Ano - Caderno - 2',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-86203-47-3',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/7-ano/7-ano-_-caderno-3.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-7-3.png',
                  bundle: 'F_fundamental',
                  name: '7º Ano - Caderno 3',
                  segment: '7',
                  discipline: '',
                  description: 'Coleção Didática - 7º Ano - Caderno - 3',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-86203-48-0',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/7-ano/7-ano-_-caderno-4.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-7-4.png',
                  bundle: 'F_fundamental',
                  name: '7º Ano - Caderno 4',
                  segment: '7',
                  discipline: '',
                  description: 'Coleção Didática - 7º Ano - Caderno - 4',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-86203-45-9',
                },
              ]
            },
            {
              name: '8º Ano',
              otherName: '',
              permission: 'segmento-fundamental-i',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/8-ano/8-ano-_-caderno-1-web.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-8-1.png',
                  bundle: 'F_fundamental',
                  name: '8º Ano - Caderno 1',
                  segment: '8',
                  discipline: '',
                  description: 'Coleção Didática - 8º Ano - Caderno - 1',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-86203-44-2',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/8-ano/8-ano-_-caderno-2.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-8-2.png',
                  bundle: 'F_fundamental',
                  name: '8º Ano - Caderno 2',
                  segment: '8',
                  discipline: '',
                  description: 'Coleção Didática - 8º Ano - Caderno - 2',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-86203-46-6',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/8-ano/8-ano-_-caderno-3.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-8-3.png',
                  bundle: 'F_fundamental',
                  name: '8º Ano - Caderno 3',
                  segment: '8',
                  discipline: '',
                  description: 'Coleção Didática - 8º Ano - Caderno - 3',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-86203-53-4',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/8-ano/8-ano-_-caderno-4.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-8-4.png',
                  bundle: 'F_fundamental',
                  name: '8º Ano - Caderno 4',
                  segment: '8',
                  discipline: '',
                  description: 'Coleção Didática - 8º Ano - Caderno - 4',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-86203-54-1',
                },
              ]
            },
            {
              name: '9º Ano',
              otherName: '',
              permission: 'segmento-fundamental-i',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/9-ano/caderno%201_9%C2%BAano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-9-all.png',
                  bundle: 'F_fundamental',
                  name: '9º Ano - Caderno 1',
                  segment: '9',
                  discipline: '',
                  description: 'Coleção Didática - 9º Ano - Caderno - 1',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-86203-55-8',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/9-ano/caderno%202_9%C2%BAano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-9-all.png',
                  bundle: 'F_fundamental',
                  name: '9º Ano - Caderno 2',
                  segment: '9',
                  discipline: '',
                  description: 'Coleção Didática - 9º Ano - Caderno - 2',
                  toolTip: ' ',
                  isbn: 'ISBN:  ',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/9-ano/caderno%203_9%C2%BAano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-9-all.png',
                  bundle: 'F_fundamental',
                  name: '9º Ano - Caderno 3',
                  segment: '9',
                  discipline: '',
                  description: 'Coleção Didática - 9º Ano - Caderno - 3',
                  toolTip: ' ',
                  isbn: 'ISBN:  ',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/9-ano/caderno%204_9%C2%BAano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-9-all.png',
                  bundle: 'F_fundamental',
                  name: '9º Ano - Caderno 4',
                  segment: '9',
                  discipline: '',
                  description: 'Coleção Didática - 9º Ano - Caderno - 4',
                  toolTip: ' ',
                  isbn: 'ISBN:  ',
                },
              ]
            },
            {
              name: 'Material Complementar Espanhol',
              otherName: '',
              permission: 'segmento-fundamental-i',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/materiais-complementares/esp-6-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-ES-6.png',
                  bundle: 'F_fundamental',
                  name: 'Espanhol - 6º Ano',
                  segment: '6',
                  discipline: 'Língua Espanhola',
                  description: 'Espanhol - 6',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-8451-061-0 ',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/materiais-complementares/esp-7-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-ES-7.png',
                  bundle: 'F_fundamental',
                  name: 'Espanhol - 7º Ano',
                  segment: '7',
                  discipline: 'Língua Espanhola',
                  description: 'Espanhol - 7',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-8451-062-7',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/materiais-complementares/esp-8-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-ES-8.png',
                  bundle: 'F_fundamental',
                  name: 'Espanhol - 8º Ano',
                  segment: '8',
                  discipline: 'Língua Espanhola',
                  description: 'Espanhol - 8',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-8451-063-4',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/materiais-complementares/esp-9-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-ES-9.png',
                  bundle: 'F_fundamental',
                  name: 'Espanhol - 9º Ano',
                  segment: '9',
                  discipline: 'Língua Espanhola',
                  description: 'Espanhol - 9',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-8451-064-1 ',
                },
              ]
            },
            {
              name: 'Material Complementar Inglês',
              otherName: '',
              permission: 'segmento-fundamental-i',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/materiais-complementares/ingles-_-ef-2-_-6-ano-2.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-US-6.png',
                  bundle: 'F_fundamental',
                  name: 'Inglês - 6º Ano',
                  segment: '6',
                  discipline: 'Língua Inglesa',
                  description: 'Material Complementar - Nível - 6',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-8451-064-1 ',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/materiais-complementares/ingles-_-ef-2-_-7-ano-2.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-US-7.png',
                  bundle: 'F_fundamental',
                  name: 'Inglês - 7º Ano',
                  segment: '7',
                  discipline: 'Língua Inglesa',
                  description: '7',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-8451-064-1 ',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/materiais-complementares/ingles-_-ef-2-_-8-ano-2.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-US-8.png',
                  bundle: 'F_fundamental',
                  name: 'Inglês - 8º Ano',
                  segment: '8',
                  discipline: 'Língua Inglesa',
                  description: '8',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-8451-064-1 ',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/colecao-cpv/materiais-complementares/ingles-_-ef-2-_-9-ano-2.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/tbw_fund2-US-9.png',
                  bundle: 'F_fundamental',
                  name: 'Inglês - 9º Ano',
                  segment: '9',
                  discipline: 'Língua Inglesa',
                  description: '9',
                  toolTip: ' ',
                  isbn: 'ISBN: 978-85-8451-064-1 ',
                },
              ]
            },
          ],
        },
        {
          id: 2,
          name: 'Simulados',
          iconClass: 'fa-solid fa-box-archive fa-sm mr-1',
          link_name: 'fundamental-2-simulados',
          colorCard: {
            'background-color': '#4ac8aa',
            'border:': '1px solid #4ac8aa',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-fundamental-ii',
          bg__link: 'fundamental-i',
          turmas: [
            {
              name: '6º Ano',
              otherName: '',
              permission: 'segmento-fundamental-i',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/simulados/6-ano/sim_ef-2_6o_ano_2o_bim.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/base-fund2-simulado-6-2bi.png',
                  bundle: 'F_fundamental',
                  name: 'Simulado - 6º Ano',
                  segment: '6',
                  discipline: '',
                  description: 'Simulado Ensino Fundamental II',
                  description2: '6º Ano – 2º Bimestre',
                  toolTip: '',
                  isbn: 'Simulado',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/simulados/6-ano/sim_ef-2_6o_ano_3o_bim.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/base-fund2-simulado-6-3bi.png',
                  bundle: 'F_fundamental',
                  name: 'Simulado - 6º Ano – 3º Bimestre',
                  segment: '6',
                  discipline: '',
                  description: 'Simulado Ensino Fundamental II',
                  description2: '6º Ano – 3º Bimestre',
                  toolTip: '',
                  isbn: 'Simulado',
                },
              ]
            },
            {
              name: '7º Ano',
              otherName: '',
              permission: 'segmento-fundamental-i',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/simulados/7-ano/sim_ef-2_7o_ano_2o_bim.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/base-fund2-simulado-7-2bi.png',
                  bundle: 'F_fundamental',
                  name: 'Simulado - 7º Ano',
                  segment: '7',
                  discipline: '',
                  description: 'Simulado Ensino Fundamental II',
                  description2: '7º Ano – 2º Bimestre',
                  toolTip: '',
                  isbn: 'Simulado',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/simulados/7-ano/sim_ef-2_7o_ano_3o_bim.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/base-fund2-simulado-7-3bi.png',
                  bundle: 'F_fundamental',
                  name: 'Simulado - 7º Ano – 3º Bimestre',
                  segment: '7',
                  discipline: '',
                  description: 'Simulado Ensino Fundamental II',
                  description2: '7º Ano – 3º Bimestre',
                  toolTip: '',
                  isbn: 'Simulado',
                },
              ]
            },
            {
              name: '8º Ano',
              otherName: '',
              permission: 'segmento-fundamental-i',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/simulados/8-ano/sim_ef-2_8o_ano_2o_bim.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/base-fund2-simulado-8-2bi.png',
                  bundle: 'F_fundamental',
                  name: 'Simulado - 8º Ano',
                  segment: '8',
                  discipline: '',
                  description: 'Simulado Ensino Fundamental II',
                  description2: '8º Ano – 2º Bimestre',
                  toolTip: '',
                  isbn: 'Simulado',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/simulados/8-ano/sim_ef-2_8o_ano_3o_bim.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/base-fund2-simulado-8-3bi.png',
                  bundle: 'F_fundamental',
                  name: 'Simulado - 8º Ano – 3º Bimestre',
                  segment: '8',
                  discipline: '',
                  description: 'Simulado Ensino Fundamental II',
                  description2: '8º Ano – 3º Bimestre',
                  toolTip: '',
                  isbn: 'Simulado',
                },
              ]
            },
            {
              name: '9º Ano',
              otherName: '',
              permission: 'segmento-fundamental-i',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/simulados/9-ano/sim_ef-2_9o_ano_2o_bim.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/base-fund2-simulado-9-2bi.png',
                  bundle: 'F_fundamental',
                  name: 'Simulado - 9º Ano',
                  segment: '9',
                  discipline: '',
                  description: 'Simulado Ensino Fundamental II',
                  description2: '9º Ano – 2º Bimestre',
                  toolTip: '',
                  isbn: 'Simulado',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/simulados/9-ano/sim_ef-2_9o_ano_3o_bim.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/base-fund2-simulado-9-3bi.png',
                  bundle: 'F_fundamental',
                  name: 'Simulado - 9º Ano – 3º Bimestre',
                  segment: '9',
                  discipline: '',
                  description: 'Simulado Ensino Fundamental II',
                  description2: '9º Ano – 3º Bimestre',
                  toolTip: '',
                  isbn: 'Simulado',
                },
              ]
            },
          ],
        },
        {
          id: 3,
          name: 'Programação',
          iconClass: 'fa-solid fa-calendar-days fa-sm mr-1',
          link_name: 'fundamntal-2-programacao',
          colorCard: {
            'background-color': '#a7dc48',
            'border:': '1px solid #a7dc48',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-fundamental-ii',
          bg__link: 'fundamental-ii',
          books: [
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'ensino-fundamental-2/programacao/programacao-ensino-fundamental-II.pdf',
              videoId: '',
              src: '',
              bundle: 'F_fundamental',
              name: 'Proposta Pedagógica e Programação',
              segment: '8',
              discipline: '',
              description: 'Programação do Ensino Fundamental 2 Proposta Pedagógica',
              description2: '',
              toolTip: '',
              isbn: 'Simulado',
            }
          ]
        },
        {
          id: 4,
          name: 'Manual',
          iconClass: 'fa-solid fa-notebook fa-sm mr-1',
          link_name: 'fundamental-2-manual',
          colorCard: {
            'background-color': '#fc5b5b',
            'border:': '1px solid #fc5b5b',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-fundamental-ii',
          bg__link: 'medio',
          turmas: [
            {
              name: '6º Ano',
              otherName: '',
              permission: 'segmento-fundamental-ii',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/6-ano/manual-coodenador.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-manual-coordenador.png',
                  bundle: 'F_FUND2',
                  name: 'Manual de Orientações para Coordenadores',
                  segment: '',
                  discipline: '',
                  description: 'Manual de Orientações para o Coordenador',
                  toolTip: '',
                  isbn: 'Manual',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/6-ano/Manual-Educacao-Fisica-EF2.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor_3.png',
                  bundle: 'F_FUND2',
                  name: 'Manual de Orientações - Educação Física',
                  segment: '',
                  discipline: '',
                  description: 'Projetos Interdisciplinares',
                  toolTip: '',
                  isbn: 'Projetos',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'ensino-fundamental-2/manual/6-ano/cadprof-_-ef-2-_-arte-_-6-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor – Artes',
                  segment: '6',
                  discipline: 'Artes',
                  description: 'artes 6o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'ensino-fundamental-2/manual/6-ano/cadprof-_-ef-2-_-ciencias-_-6-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor – Ciências Naturais',
                  segment: '6',
                  discipline: 'Ciências',
                  description: 'ciencias naturais 6o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'ensino-fundamental-2/manual/6-ano/cadprof-_-ef-2-_-geografia-_-6-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor – Geografia',
                  segment: '6',
                  discipline: 'Geografia',
                  description: 'geografia 6o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'ensino-fundamental-2/manual/6-ano/cadprof-_-ef-2-_-espanhol-_-6-ano-1.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor – Espanhol',
                  segment: '6',
                  discipline: 'Língua Espanhola',
                  description: 'espanhol 6o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'ensino-fundamental-2/manual/6-ano/cadprof-_-ef-2-_-historia-_-6-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor – História',
                  segment: '6',
                  discipline: 'História',
                  description: 'historia 6o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'ensino-fundamental-2/manual/6-ano/cadprof-_-ef-2-_-ingles-_-6-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor – Inglês',
                  segment: '6',
                  discipline: 'Língua Inglesa',
                  description: 'ingles 6o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'ensino-fundamental-2/manual/6-ano/cadprof-_-ef-2-_-lp-_-6-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor – Língua Portuguesa',
                  segment: '6',
                  discipline: 'Língua Portuguesa',
                  description: 'lingua portuguesa 6o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'ensino-fundamental-2/manual/6-ano/cadprof-_-ef-2-_-mat-_-6-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor – Matemática',
                  segment: '6',
                  discipline: 'Matemática',
                  description: 'matematica 6o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },
              ]
            },
            {
              name: '7º Ano',
              otherName: '',
              permission: 'segmento-fundamental-ii',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/7-ano/manual-coodenador.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-manual-coordenador.png',
                  bundle: 'F_FUND2',
                  name: 'Manual de Orientações para Coordenadores',
                  segment: '',
                  discipline: '',
                  description: 'Manual de Orientações para o Coordenador',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/7-ano/Manual-Educacao-Fisica-EF2.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor_3.png',
                  bundle: 'F_FUND2',
                  name: 'Manual de Orientações - Educação Física',
                  segment: '',
                  discipline: '',
                  description: 'Projetos Interdisciplinares',
                  toolTip: '',
                  isbn: 'Projetos',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/7-ano/cadprof-_-ef-2-_-arte-_-7-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Artes',
                  segment: '7',
                  discipline: 'Artes',
                  description: 'artes 7o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/7-ano/cadprof-_-ef-2-_-ciencias-_-7-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Ciências Naturais',
                  segment: '7',
                  discipline: 'Ciências',
                  description: 'ciencias naturais 7o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/7-ano/cadprof-_-ef-2-_-geografia-_-7-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Geografia',
                  segment: '7',
                  discipline: 'Geografia',
                  description: 'geografia 7o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/7-ano/cadprof-_-ef-2-_-espanhol-_-7-ano-1.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Espanhol',
                  segment: '7',
                  discipline: 'Língua Espanhola',
                  description: 'espanhol 7o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/7-ano/cadprof-_-ef-2-_-historia-_-7-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - História',
                  segment: '7',
                  discipline: 'História',
                  description: 'historia 7o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/7-ano/cadprof-_-ef-2-_-ingles-_-7-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Inglês',
                  segment: '7',
                  discipline: 'Língua Inglesa',
                  description: 'ingles 7o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/7-ano/cadprof-_-ef-2-_-lp-_-7-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Língua Portuguesa',
                  segment: '7',
                  discipline: 'Língua Portuguesa',
                  description: 'lingua portuguesa 7o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/7-ano/cadprof-_-ef-2-_-mat-_-7-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Matemática',
                  segment: '7',
                  discipline: 'Matemática',
                  description: 'matematica 7o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },
              ]
            },
            {
              name: '8º Ano',
              otherName: '',
              permission: 'segmento-fundamental-ii',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/8-ano/manual-coodenador.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-manual-coordenador.png',
                  bundle: 'F_FUND2',
                  name: 'Manual de Orientações para Coordenadores',
                  segment: '',
                  discipline: '',
                  description: 'Manual de Orientações para o Coordenador',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/8-ano/Manual-Educacao-Fisica-EF2.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor_3.png',
                  bundle: 'F_FUND2',
                  name: 'Manual de Orientações - Educação Física',
                  segment: '',
                  discipline: '',
                  description: 'Projetos Interdisciplinares',
                  toolTip: '',
                  isbn: 'Projetos',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/8-ano/cadprof-_-ef-2-_-arte-_-8-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Artes',
                  segment: '7',
                  discipline: 'Artes',
                  description: 'artes 8o Ano',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/8-ano/cadprof-_-ef-2-_-ciencias-_-8-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Ciências Naturais',
                  segment: '7',
                  discipline: 'Ciências',
                  description: 'ciencias naturais 8o Ano',
                  toolTip: '',
                  isbn: 'Manual',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/8-ano/cadprof-_-ef-2-_-geografia-_-8-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Geografia',
                  segment: '7',
                  discipline: 'Geografia',
                  description: 'geografia 8o Ano',
                  toolTip: '',
                  isbn: 'Manual',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/8-ano/cadprof-_-ef-2-_-espanhol-_-8-ano-1.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Espanhol',
                  segment: '7',
                  discipline: 'Língua Espanhola',
                  description: 'espanhol 8o Ano',
                  toolTip: '',
                  isbn: 'Manual',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/8-ano/cadprof-_-ef-2-_-historia-_-8-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - História',
                  segment: '7',
                  discipline: 'História',
                  description: 'historia 8o Ano',
                  toolTip: '',
                  isbn: 'Manual',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/8-ano/cadprof-_-ef-2-_-ingles-_-8-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Inglês',
                  segment: '7',
                  discipline: 'Língua Inglesa',
                  description: 'ingles 8o Ano',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/8-ano/cadprof-_-ef-2-_-lp-_-8-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Língua Portuguesa',
                  segment: '7',
                  discipline: 'Língua Portuguesa',
                  description: 'lingua portuguesa 8o Ano',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/8-ano/cadprof-_-ef-2-_-mat-_-8-ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Matemática - Álgebra',
                  segment: '7',
                  discipline: 'Matemática',
                  description: 'matematica 8o Ano',
                  toolTip: '',
                  isbn: 'Manual',
                },
              ]
            },
            {
              name: '9º Ano',
              otherName: '',
              permission: 'segmento-fundamental-ii',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/9-ano/CadProf_EF2_Arte_9_Ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Artes',
                  segment: '7',
                  discipline: 'Artes',
                  description: 'artes 9o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/9-ano/CadProf_EF2_Ciencias_9_Ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Ciências Naturais',
                  segment: '7',
                  discipline: 'Ciências',
                  description: 'ciencias naturais 9o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/9-ano/CadProf_EF2_Geografia_9_Ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Geografia',
                  segment: '7',
                  discipline: 'Geografia',
                  description: 'geografia 9o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/9-ano/CadProf_EF2_Mat_Geometria_9_Ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Geometria',
                  segment: '7',
                  discipline: 'geometria',
                  description: 'geometria 9o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/9-ano/CadProf_EF2_Historia_9_Ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - História',
                  segment: '7',
                  discipline: 'História',
                  description: 'historia 9o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/9-ano/CadProf_EF2_LP_9_Ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Língua Portuguesa',
                  segment: '7',
                  discipline: 'Língua Portuguesa',
                  description: 'lingua portuguesa 9o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'ensino-fundamental-2/manual/9-ano/CadProf_EF2_Mat_9_Ano.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
                  bundle: 'F_FUND2',
                  name: 'Caderno do Professor - Matemática - Álgebra',
                  segment: '9',
                  discipline: 'Matemática',
                  description: 'matematica 9o ano',
                  toolTip: '',
                  isbn: 'Manual',
                },
              ]
            },
          ],
        },
        {
          id: 5,
          name: 'Proj. Interdisciplinares',
          iconClass: 'fa-duotone fa-book-open-cover fa-sm mr-1',
          link_name: 'fundamental-2-projetos-interdisciplinares',
          colorCard: {
            'background-color': '#fa6d9e',
            'border:': '1px solid #fa6d9e',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-fundamental-ii',
          bg__link: 'pre-vestibular',
          books: [
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'ensino-fundamental-2/projetos-interdisciplinares/projetos-interdisciplinares-ef-ii-2019-final.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
              bundle: 'F_fundamental',
              name: 'Projetos Interdisciplinares',
              segment: 'all',
              discipline: '',
              description: 'Ensino Fundamental II - Projetos Interdisciplinares',
              toolTip: ' ',
              isbn: 'Programação ',
            },
          ]
        },
      ],
    };
  },

  created() {
    this.$emit('update-header', {
      title: this.pageTitle,
      subtitle: this.pageSubtitle,
    });
  },

  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },

  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },

    isToggleMaternalI() {
      this.isMaternalICollapsed = !this.isMaternalICollapsed
    },

    setActive(index) {
      this.activeIndex = index;
    },

    clearActive(index) {
      if (this.activeIndex === index) {
        this.activeIndex = [];
      }
    },

    toggleCollapse(type, idx) {
      if (!Array.isArray(this.collapsedStates[type])) {
        this.$set(this.collapseStates, type, [])
      }

      this.collapsedStates[type].forEach((_, index) => {
        this.$set(this.collapsedStates[type], index, index === idx ? !this.collapsedStates[type][idx] : false)
      });
    },

    formatParam(param) {
      return param.replace(/\s+/g, '-');
    },
  },
};
</script>

<style scoped>
.main {
  margin-top: 30px;
}

.card_sistemacpv {
  border-radius: 8px;
  color: #3A1C53;
}
</style>
